import { render, staticRenderFns } from "./select-order.vue?vue&type=template&id=3c13f074&scoped=true&lang=pug&"
import script from "./select-order.vue?vue&type=script&lang=js&"
export * from "./select-order.vue?vue&type=script&lang=js&"
import style0 from "./select-order.vue?vue&type=style&index=0&id=3c13f074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13f074",
  null
  
)

export default component.exports